export function initCheckoutPage() {
  const pageTitleCheckout = document.querySelector('h1.page-title-checkout');
  if(!pageTitleCheckout) return;

  const pageTitleCheckoutText = pageTitleCheckout.textContent;

  const orderReviewEl = document.getElementById('order_review');
  const productNameEl = orderReviewEl.querySelector('td.product-name');
  const productName = String(productNameEl.childNodes[0].textContent).toLowerCase();

  pageTitleCheckout.textContent = `${pageTitleCheckoutText} - ${productName}`;
}